<template>
  <v-file-input
    v-model="arquivo"
    :label="titulo_label"
    v-bind="$attrs"
    prepend-icon=""
    append-icon="mdi-file"
  >
    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-file-input>
</template>

<script>
export default {
  model: {
    prop: "model_value",
    event: "change"
  },
  props: {
    model_value: {
      type: File
    },
    titulo_label: {
      type: String,
      default: 'Data'
    }
  },
  data() {
    return {
      arquivo: null
    }
  },
  watch: {
    model_value (valor) {
      if (!valor) this.arquivo = null;
    },
    arquivo (valor) {
      this.$emit('change', valor);
    }
  }
}
</script>
